import { useEffect, useState } from 'react';

const COLORS = ['var(--nr-accent-fill)', 'var(--nr-status-exploring)', 'var(--nr-status-building)', 'var(--nr-status-shipped)', 'var(--nr-accent-text)'];
const PARTICLE_COUNT = 60;

interface Particle {
  id: number;
  color: string;
  left: number;
  size: number;
  delay: number;
  duration: number;
}

export function ConfettiEffect() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const particles: Particle[] = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
    id: i,
    color: COLORS[Math.floor(Math.random() * COLORS.length)] as string,
    left: Math.random() * 100,
    size: 4 + Math.random() * 4,
    delay: Math.random() * 1.2,
    duration: 1.5 + Math.random() * 2,
  }));

  return (
    <div className="confetti-container" aria-hidden="true">
      {particles.map((p) => (
        <div
          key={p.id}
          className="confetti-dot"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            backgroundColor: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
